<template>
  <div class="card">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-6">
          <h5 class="align-baseline">
            {{ $t('Detalhes') }}
          </h5>
        </div>
        <div class="col-6 text-right">
          <button class="btn btn-secondary mr-2" v-b-modal.osInterna>OS de Transição</button>
          <button class="btn btn-dark mr-2" v-b-toggle.collapse-detalhes
            @click="isDetalhesVisible = !isDetalhesVisible">
            <span v-if="!isDetalhesVisible">
              <i class="fas fa-plus mr-1"></i>&nbsp; {{ $t('Mostrar') }}
            </span>
            <span v-if="isDetalhesVisible">
              <i class="fas fa-minus mr-1"></i>&nbsp; {{ $t('Esconder') }}
            </span>
          </button>
        </div>
      </div>
    </div>
    <b-collapse id="collapse-detalhes" class="card-body">
      <div class="row">
        <div class="form-group col-lg-3 col-md-6">
          <span class="text-muted">{{ $t('Execuções') }}</span><br />
          <span class="text-lg badge badge-success font-weight-bold"
            :class="os && os.execucao_final && os.execucao_final.dt_final ? 'badge-success' : 'badge-warning'">
            {{ os && os.execucao_final && os.execucao_final.dt_final ? 'FINALIZADA' : $t('Pendente') }}
          </span>
        </div>
        <div class="form-group col-lg-3 col-md-6">
          <span class="text-muted">{{ $t('Placa') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{ os ? os.nr_placa : null }}
          </span>
        </div>
        <div v-if="os.segmento" class="form-group col-lg-2 col-md-6">
          <span class="text-muted">{{ $t('Segmento') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{ os.segmento.ds_grupo }}
          </span>
        </div>
        <div v-if="os.socorro_emrota" class="form-group col-lg-3 col-md-6">
          <span class="text-muted">{{ $t('Telefone') }}:</span><br />
          <span class="text-lg font-weight-bold">
            {{ os.socorro_emrota.nr_telefone }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-3 col-md-3">
          <span class="text-muted">{{ $t('Data') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{ os? os.dt_os : null | formatDate("DD/MM/YYYY HH:mm:ss") }}
          </span>
        </div>
        <div class="form-group col-lg-3 col-md-4">
          <span class="text-muted">{{ $t('Início') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{
  os && os.dt_inicial
  ? os.dt_inicial
  : "-" | formatDate("DD/MM/YYYY HH:mm:ss")
            }}
          </span>
        </div>
        <div class="form-group col-lg-2 col-md-3">
          <span class="text-muted">{{ $t('Final') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{
  os && os.dt_final
  ? os.dt_final
  : "-" | formatDate("DD/MM/YYYY HH:mm:ss")
            }}
          </span>
        </div>        
        <div class="form-group col-lg-3 col-md-4">
          <span class="text-muted">{{ $t('Fornecedor') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{ os.ds_fornecedor }}
          </span>
        </div>
      </div>
      <div class="row">
        <!-- <div class="form-group col-lg-2 col-md-6">
          <span class="text-muted">Cunho</span><br />
          <span class="text-lg font-weight-bold">
            {{ os ? os.ds_cunho : "" }}
          </span>
        </div> -->
        <div class="form-group col-lg-3 col-md-6">
          <span class="text-muted">{{ $t('Tipo') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{ os? os.ds_tipo : "" }}
          </span>
        </div>
        <div class="form-group col-lg-3 col-md-6">
          <span class="text-muted">{{ $t('Ciclo preventiva') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{  os && os.ciclo_preventiva && os.nr_seq_tipo != 13 ? os.ciclo_preventiva.ds_ciclo : os.ds_preditivo }}
          </span>
        </div>
        <div class="form-group col-lg-2 col-md-6">
          <span class="text-muted">{{ $t('Criticidade') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{
  os && os.criticidade ? os.criticidade.ds_criticidade : "-"
            }}
          </span>
        </div>
        <div class="form-group col-lg-2 col-md-6">
          <span class="text-muted">{{ $t('Previsão de Atendimento') }}</span><br />
          <span class="text-lg font-weight-bold">
            {{
              this.previsaoAtendimento
            }}
          </span>
        </div>
        <div class="form-group col-lg-2 col-md-6">
          <span class="text-muted">{{ $t('Motorista') }}</span><br />
          <span class="text-lg">
            {{
              this.nomeMotorista.ds_colaborador
            }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-2 col-md-6">
          <span class="text-muted">{{ $t('Atendimento do Item') }}</span><br />
          <div v-for="item in historicoAtendimento" :key="item.nr_sequencial">
            <span class="text-lg">
              {{ item.nr_sequencial }} - {{ item.dt_os | formatDate("DD/MM/YYYY") }}
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="text-muted">{{ $t('Observações') }}</span><br />
          <textarea cols="30" rows="4" class="form-control" v-model="observacao" :disabled="true"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="text-muted">{{ $t('Imagens') }}</span><br />
          <div v-for="img in imgs" :key="img.id">
            <img :src="validaLinkImg(img) + img.ds_arquivo" class="imgOs" @click="toggler = !toggler" width="200"
              height="200">
          </div>

          <!-- <FsLightbox :toggler="toggler" :sources="['https://ginfo.inovess.com.br/frota/os_manut/arquivos/1670522066_WhatsApp_Image_2022_12_08_at_13.13.15__2_.jpeg']" /> -->
        </div>
      </div>
      <div class="row d-none">
        <div class="col-12 mt-3 text-right">
          <button class="btn btn-success" type="button" @click="salvar()"
            :disabled="os.ds_observacao === observacao || saving">
            <i class="fas fa-check mr-2"></i>{{ $t('Salvar') }}
          </button>
        </div>
      </div>
    </b-collapse>
    <modal-os-interna :os="os.os_interna[0]"></modal-os-interna>
  </div>
  

</template>
<script>
// import FsLightbox from "fslightbox-vue";
import ModalOsInterna from './Modais/ModalOsInterna.vue'

export default {
  // components: { FsLightbox },
  data() {
    return {
      linkLocal: window.location.hostname,
      isDetalhesVisible: false,
      nrSeqOs: this.$route.params.id,
      observacao: '',
      selectedClifor: 0,
      saving: false,
      toggler: false,
      linkImg: '',
      previsaoAtendimento: '',
      tipo_os: '',
      showBtnOsIterna: false
    }
  },
  components: {
    ModalOsInterna
  },

  created() {
  },

  // https://log20.ginfo.inovess.com.br/checklist/relatorio/arquivos/1676380613_image26602426716442897.jpg
  // https://ginfo.inovess.com.br/frota/os_manut/arquivos/1676380613_image26602426716442897.jpg
  computed: {
    os() {
      const os = this.$store.getters['os/details']

      if (!os) {
        return {}
      }


      this.setObservacao(os.ds_observacao, os.ds_observacao_sinistro)

      this.setDtOs(os.dt_os, os.hr_sla)

      this.setTipoOs(os.ds_tipo)

      this.setOsInterna(os)

      return os
    },
    historicoAtendimento() {
      const historico = this.os.historicoItem

      return historico
    },
    imgs() {
      return this.os.imgOs 
    },
    nomeMotorista() {
      return this.os.g_clifor_motorista
    },
    imgCarrousel() {
      let arrayImg = []
      for (let i = 0; i <= this.os.imgOs.length; i++) {
        arrayImg.push('https://ginfo.inovess.com.br/frota/os_manut/arquivos/' + '1670522066_WhatsApp_Image_2022_12_08_at_13.13.15__2_.jpeg')
      }
      return arrayImg
    }
  },

  methods: {
    setOsInterna(os){
      // if(os.os_interna.length >= 0){
        this.showBtnOsIterna = true
      // }

      // this.showBtnOsIterna = false
    },
    validaLinkImg(value) {
      let empresaBruto = window.location.hostname
      let empresa = empresaBruto.split(".")
      if(this.tipo_os == 'CHECK CONFORMIDADE') {
        return 'https://log20.ginfo.inovess.com.br/checklist_qualidade/relatorio/arquivos/'
      }

      if(this.os.nr_seq_tipo == '20'){
        return 'https://api.ginfo.inovess.com.br/files/'
      }

      if(this.tipo_os == 'CHECKLIST'){
        return 'https://log20.ginfo.inovess.com.br/checklist/relatorio/arquivos/'
      } else {
        if (value.tp_origem == 'A') {
          return `http://public.ginfo.app.br/documentos/`
        } else {
          return `https://ginfo.inovess.com.br/frota/os_manut/arquivos/`
        }
      }
    },
    setTipoOs(value){
      this.tipo_os = value
    },
    showImg(index) {
      this.index = index
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    setObservacao(value, ds_observacao_sinistro) {
      this.observacao = value + (ds_observacao_sinistro ? ' ' + ds_observacao_sinistro : '')
    },

    setDtOs(dtOs, hrSla){
      const dateOs = new Date(dtOs)
      const data = `${hrSla}`
      const hora = data.substring(0, 2)
      const minutos = data.substring(3, 5)
      dateOs.setHours(dateOs.getHours() + Number(hora))
      dateOs.setMinutes(dateOs.getMinutes() + Number(minutos))
      this.previsaoAtendimento = `${dateOs.getHours()}:${String(dateOs.getMinutes()).padStart(2, "0")}`
    },

    salvar() {
      try {
        this.$root.confirmIdentity({
          onConfirmIdentity: (tecnicoId) => {
            this.selectedClifor = tecnicoId

            this.atualizar()
          }
        })
      } catch (error) {
        console.error(error)
      }
    },

    atualizar() {
      this.saving = true
      this.$store
        .dispatch('os/updateObservacao', {
          id: this.nrSeqOs,
          data: {
            nr_seq_clifor: this.selectedClifor,
            ds_observacao: this.observacao
          }
        })
        .then(response => {
          this.reload()
          return true
        })
        .catch(error => {
          console.error(error)
          this.$swal.fire({
            title: 'Oops!',
            text: 'Falha ao atualizar a observação. Tente novamente.',
            icon: 'error'
          })
        })
        .finally(() => {
          this.saving = false
        })
    },

    reload() {
      return this.$store.dispatch('os/getDetails', {
        nrSequencial: this.nrSeqOs
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.icon--custom {
  top: 50px;
}

.imgOs {
  margin: 4px 4px;
  cursor: pointer;
}
</style>
